module.exports = __webpack_public_path__ + "static/Stacker-c34be869e300531b6170baa7c6be29e1.jpg";